import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Profile from "../screens/auth/Profile";
import Career from "../screens/users/Career";
import Categories from "../screens/auth/Categories";
import Products from "../screens/auth/Products";
import ProductCreate from "../components/AdminSideComponents/Products/ProductCreate";
import ProductEdit from "../components/AdminSideComponents/Products/ProductEdit";
import ProductView from "../components/AdminSideComponents/Products/ProductView";
import CarrierList from "../components/AdminSideComponents/Carrier/CarrierList";
import JobApplication from "../screens/auth/JobApplication";
import Testimonial from "../screens/auth/Testimonial";
import Faq from "../screens/auth/FAQAdmin";
import Inquiry from "../screens/auth/EnquiryAdmin";
import BlogAdmin from "../screens/auth/BlogAdmin";
import AdminHeroPage from "../screens/auth/AdminHeroPage";
import Staff from "../screens/auth/Staff";
import AllUser from "../components/AdminSideComponents/User/AllUser";
import LeadDashboard from "../screens/auth/LeadDashboard ";
import ServiceDetails from "../screens/users/Servicedetails";
import Blog from "../screens/users/Blog";
import BlogDetails from "../components/User/Blog/Blogdetails";
import PrivacyPolicyPage from "../components/User/Common/PrivacyPolicyPage";
import TermsAndConditionsPage from "../components/User/Common/TermsAndConditionsPage";
import SupportPage from "../components/User/Common/SupportPage";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/category",
    component: <Categories />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/product",
    component: <Products />,
  },
  {
    path: "/products/create",
    component: <ProductCreate />,
  },
  {
    path: "/products/:id/edit",
    component: <ProductEdit />,
  },
  {
    path: "/products/:id",
    component: <ProductView />,
  },
  {
    path: "/carrier",
    component: <CarrierList />,
  },
  {
    path: "/job",
    component: <JobApplication />,
  },
  {
    path: "/testimonial",
    component: <Testimonial />,
  },
  {
    path: "/faq",
    component: <Faq />,
  },
  {
    path: "/inquiry",
    component: <Inquiry />,
  },
  {
    path: "/blog",
    component: <BlogAdmin />,
  },
  {
    path: "/hero",
    component: <AdminHeroPage />,
  },
  {
    path: "/staff",
    component: <Staff />,
  },
  {
    path: "/user",
    component: <AllUser />,
  },
  {
    path: "/lead",
    component: <LeadDashboard />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/career",
    component: <Career />,
  },
  {
    path: "/user-blog",
    component: <Blog />,
  },
  {
    path: "/blog/:id",
    component: <BlogDetails />,
  },
  {
    path: "/serviceDetails/:id",
    component: <ServiceDetails />,
  },
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicyPage />,
  },
  {
    path: "/support",
    component: <SupportPage />,
  },
  {
    path: "/termcondition",
    component: <TermsAndConditionsPage />,
  },
];
